import { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config';
import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';
import { Page, Params, SearchClient, SearchResponse } from '@empathybroker/tsclient-search';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { FilterTypeEnum } from '../../../enums';

import {
  ActionClass,
  ContextState,
  Dictionary,
  Filter,
  Pagination,
  RegularFilterConfig,
  RegularFilterSelectedValues,
  SearchState
} from '../../../models';

import { CONFIG_CONSTS } from '../../../store/config/config.consts';
import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

export class SearchAction implements ActionClass {

  public static async execute({ rootGetters }: ActionContext<SearchState, any>, payload: {
    filters: Dictionary<Filter>,
    pagination: Pagination,
    query: string,
    params?: Params,
    boost?: boolean,
    debugEnabled?: boolean
  }): Promise<SearchResponse> {
    const context: ContextState = rootGetters[`${ CONTEXT_CONSTS.moduleName }/${ CONTEXT_CONSTS.getters.context }`];
    const instanceConfig: Instance = rootGetters[`${ CONFIG_CONSTS.moduleName }/${ CONFIG_CONSTS.getters.currentInstance }`];
    const searchClient: SearchClient = CONTAINER.get<(context: ContextState, instanceConfig: Instance) => SearchClient>(
      TYPES.SearchClient)(context, instanceConfig);
    try {
      const params = Object.assign(SearchAction.getSearchFilters(payload.filters), payload.params);
      const page = SearchAction.getSearchPage(payload.pagination);
      let searchResponse: SearchResponse;
      if (!payload.boost) {
        searchResponse = (await searchClient.search(payload.query, params, page, payload.debugEnabled) as SearchResponse);
      } else {
        searchResponse = (await searchClient.searchBoost(payload.query, params, page) as SearchResponse);
      }
      return searchResponse;
    } catch (error) {
      throw error;
    }
  }

  public static getSearchFilters(filters: Dictionary<Filter>): Params {
    const searchFilters: Params = { lang: undefined };
    Object.values(filters)
      .forEach((filter: Filter) => {
        if (filter.config.type === FilterTypeEnum.REGULAR) {
          const filterConfig = (filter.config as RegularFilterConfig);
          const selectedValues = (filter.selectedValues as RegularFilterSelectedValues);
          if (!!selectedValues.length) {
            const selectedValueConfig: RegularFilterValueConfig = filterConfig.values.find(
              (valueConfig: RegularFilterValueConfig) => (valueConfig.id === selectedValues[0]));
            searchFilters[(filterConfig.toolingId || filterConfig.id)] = (selectedValueConfig.taggingId || selectedValueConfig.id);
          }
        }
      });
    return searchFilters;
  }

  public static getSearchPage(pagination: Pagination): Page {
    return {
      start: ((pagination.page - 1) * pagination.itemsPerPage),
      rows: pagination.itemsPerPage
    };
  }
}
